import CoreSpinner from '@ergeon/core-components/exports/Spinner.ts';

export function Spinner({ size = 32 }: { size?: number }) {
  return <CoreSpinner active color="blue" size={size} />;
}
